
export const API_GATEWAY = "https://ba5cwilynl.execute-api.us-east-1.amazonaws.com/prod"


export interface IContactForm {
    name: string;
    email: string;
    subject: string;
    message: string;
}

export interface ISuccessResponse {
    success: boolean;
    error?: string;
}

export async function submitContactForm(formData: IContactForm): Promise<ISuccessResponse> {
      const response = await fetch(API_GATEWAY, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          action: 'contact',
          name: formData.name,
          email: formData.email,
          subject: formData.subject,
          message: formData.message,
        }),
      });

      const data = await response.json();

      return response.ok ? { success: true } : { success: false, error: data.error || 'Failed to submit contact form' };
}

export async function subscribeToNewsletter(email: string): Promise<ISuccessResponse> {
  const response = await fetch(API_GATEWAY, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      action: 'subscribe',
      email,
    }),
  });

  const data = await response.json();

  return response.ok ? { success: true } : { success: false, error: data.error || 'Failed to subscribe to newsletter' };
}

function makeFingerprint(): string {
  // Generate a simple fingerprint using a random UUID
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

export async function hitCounter(hit: string): Promise<ISuccessResponse> {
  const fingerprint = localStorage.getItem('fingerprint') || makeFingerprint()
  localStorage.setItem('fingerprint', fingerprint);

  const response = await fetch(API_GATEWAY, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      action: 'hitcounter',
      page: hit,
      user: fingerprint
    }),
  });

  const data = await response.json();

  return response.ok ? { success: true } : { success: false, error: data.error || 'Failed to update hit counter' };
}

export const apiv1 = {
  submitContactForm,
  subscribeToNewsletter,
  hitCounter,
};